import { AlertPlugin, ModalPlugin, NavbarPlugin } from "bootstrap-vue";
import Vue from "vue";

import { IconDefinition, library } from "@fortawesome/fontawesome-svg-core";
import {
    faCheckCircle, faEdit, faQuestionCircle, faTimesCircle
} from "@fortawesome/free-regular-svg-icons";
import {
    faBarcode, faCaretDown, faCaretUp, faChevronLeft, faChevronRight, faSpinner, faTimes, faUser,
    faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { registerFilters } from "@/filters";
import App from "./App.vue";
import NativeAppPlugin from "./plugins/native-app/install";
import router from "./router";

library.add(faBarcode);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faSpinner);
library.add(faTimes);
library.add(faUserCircle);
library.add(faCaretDown);
library.add(faCaretUp);
library.add(faUser);

// These icons come from a different package (solid vs. regular), so Typescript thinks they are a different
// IconDefinition. Cast them to the IconDefinition type from the core library to fix this
library.add(faQuestionCircle as IconDefinition);
library.add(faEdit as IconDefinition);
library.add(faCheckCircle as IconDefinition);
library.add(faTimesCircle as IconDefinition);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// Only register used Bootstrap plugins to reduce the size of the production build
Vue.use(AlertPlugin);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);

// Register plugins
Vue.use(NativeAppPlugin);

registerFilters(Vue);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
